/*
 * @Author: wjl 
 * @Date: 2019-10-16 12:00:09 
 * @Last Modified by: wjl
 * @Last Modified time: 2021-12-07 15:27:24
 */
<template>
  <div :class="`${$style.vipCustomer} ${isH5 && $style.isH5}`">
    <!-- 复制内容 -->
    <input type="text" :class="$style.copyInput" id="copy" readonly :value="config.vip_url" />
    <div
      :class="`${$style.proto}`"
      :style="config.page_pic ? `background-image: url('${config.page_pic}')` : ''"
    >
      <img :src="`${$cdnLink}/vip/close_1.png`" alt :class="$style.close" @click.stop="close" />
      <h1>{{ config.page_title }}</h1>
      <div>
        <div :class="$style.contact">
          <div
            :style="config.activity_name_pic ? `background-image: url('${config.activity_name_pic}')` : ''"
            :class="$style.actName"
          >{{ config.activity_name }}</div>
          <div
            :class="$style.actContent"
            :style="config.activity_pic ? `background-image: url('${config.activity_pic}')` : ''"
          >{{ config.activity_content }}</div>
        </div>
        <div
          :class="`${$style.operate}`"
          :style="config.vip_avatar_pic ? `background-image: url('${config.vip_avatar_pic}')` : ''"
        >
          <div
            :style="config.vip_pic ? `background-image: url('${config.vip_pic}')` : ''"
            @click="openQQCustom"
            :class="$style.vipPic"
          />
          <div
            :style="config.vip_avatar_note_pic ? `background-image: url('${config.vip_avatar_note_pic}')` : ''"
            :class="$style.vipAvatarNote"
          >{{ config.vip_avatar_note }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Clipboard from "clipboard";
import { isSysName } from "@/libs/utils";
import { mapState } from 'vuex';
import { visitorsAdd } from '@/api/user'

export default {
  name: "",
  props: ["isH5"],
  data() {
    return {
      cdnUrl: "//sdk-static.zhangyuqu.com/Lianyun/h5sdkv2",
      defaultCustomerLink: '',
      config: {
        sdk_name: "",
        page_pic: "", // 页面背景图
        page_title: "", // 页面置顶项名称
        activity_name: "", // 活动名称
        activity_name_pic: "", // 活动名称背景图
        activity_pic: "", // 活动背景图
        activity_content: "", // 活动文字
        vip_avatar_pic: "", // VIP头像背景图
        vip_pic: "", // VIP头像
        vip_url: "", // VIP跳转链接
        vip_avatar_note: "", // VIP头像配文
        vip_avatar_note_pic: "", // VIP头像配文配图
      },
    };
  },
  mounted() {
    this.copyInit();
    this.$nextTick(() => {
      this.getTpl();
    });
  },
  computed: {
    ...mapState({
      userState: state => state.user
    })
  },
  methods: {
    // 获取vip模板
    // async getTpl() {
    //   try {
    //     const r = await getUserSdkData({
    //       user_id: this.userState.user_id,
    //     });
    //     if (r.data.is_fixed_pic !== true) {
    //       this.config = r.data;
    //     } else {
    //       this.config = {
    //         ...this.config,
    //         page_pic: "//sdk-static.zhangyuqu.com/Lianyun/SdkImg/vip/defaultBack.png", // 页面背景图
    //         vip_url: "", // VIP跳转链接
    //       }
    //     }
    //   } catch (e) {
    //     this.config = {
    //       ...this.config,
    //       page_pic: "//sdk-static.zhangyuqu.com/Lianyun/SdkImg/vip/defaultBack.png", // 页面背景图
    //       vip_url: "", // VIP跳转链接
    //     }
    //   }
    // },
    copyInit() {
      this.copy = new Clipboard(".copy-btn");
      this.copy.on("success", (e) => {
        this.clickReport(4);
        this.$toast('复制成功');
      });
    },
    close() {
      this.$emit("close");
    },
    openQQCustom() {
      this.clickReport(5);
      this.$emit("openUrl", this.config.vip_url || this.defaultCustomerLink);
    },
    // 埋点统计 type 4.点击复制按钮 5.点击联系客服打开qq
    clickReport(type) {
      visitorsAdd({
        game_id: this.userState.appkey,
        user_id: this.userState.user_id,
        type
      })
    },
  },
};
</script>

<style lang="scss" module>
.vipCustomer {
  font-size: 0.14rem;
  width: 100%;
  height: 100%;
  overflow: auto;
  position: relative;
  .customIframe {
    position: absolute;
    left: -20000rem;
  }
  .copyInput {
    position: absolute;
    left: 0;
    top: -1000rem;
    z-index: -1;
  }
  .proto {
    background-size: 100% 100%;
    background-repeat: no-repeat;
    color: #ffffff;
    width: 100%;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    padding-bottom: 0.2rem;
    .close {
      position: absolute;
      top: 0.35rem;
      left: 0.27rem;
      width: 0.34rem;
      height: 0.22rem;
    }
    > h1 {
      padding-top: 0.3rem;
      font-size: 0.4rem;
      height: 0.4rem;
      margin-bottom: 0.1rem;
      text-align: center;
      font-weight: bold;
    }
    > div:nth-child(3) {
      display: flex;
      padding: 0 0.1rem 0 0.1rem;
      > .contact {
        flex: none;
        width: 70%;
        .actName {
          display: inline-block;
          width: 100%;
          height: 0.3rem;
          line-height: 0.5rem;
          text-align: center;
          font-size: 0.3rem;
          position: relative;
          margin-bottom: 0.15rem;
          font-weight: bold;
          // background: black;
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
        > .actContent {
          width: 100%;
          height: 3rem;
          // background: green;
          color: #000000;
          font-size: 0.28rem;
          display: flex;
          align-items: center;
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
      }
      > .operate {
        text-align: center;
        font-size: 0.3rem;
        // background: #f7805a;
        overflow: hidden;
        width: 3rem;
        height: 3.69rem;
        text-align: center;
        position: relative;
        color: #000000;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        .vipPic {
          display: inline-block;
          width: 2rem;
          height: 2rem;
          margin-top: 0.2rem;
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
        .vipAvatarNote {
          position: absolute;
          bottom: 0;
          left: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 1.4rem;
          margin-top: 0.2rem;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          // background: white;
        }
      }
      .img-portrait {
        display: block;
        width: 3rem;
        height: 3rem;
        margin: auto;
      }
    }
  }
  // h5横屏兼容
  &.isH5 {
    @media screen and (orientation: landscape) {
      .proto {
        padding-bottom: 0.1rem;
        .close {
          top: 0.17rem;
          left: 0.13rem;
          width: 0.17rem;
          height: 0.11rem;
        }
        > h1 {
          padding-top: 0.15rem;
          font-size: 0.2rem;
          height: 0.2rem;
          margin-bottom: 0.05rem;
        }
        > div:nth-child(3) {
          padding: 0 0.05rem 0 0.05rem;
          > .contact {
            width: 70%;
            .actName {
              height: 0.25rem;
              line-height: 0.25rem;
              font-size: 0.15rem;
              margin-bottom: 0.07rem;
            }
            > .actContent {
              width: 100%;
              height: 1.5rem;
              font-size: 0.14rem;
            }
          }
          > .operate {
            text-align: center;
            font-size: 0.15rem;
            overflow: hidden;
            width: 1.5rem;
            height: 1.845rem;
            text-align: center;
            > img:nth-child(1) {
              display: inline-block;
              width: 1rem;
              height: 1rem;
              margin-top: 0.1rem;
            }
            .vipAvatarNote {
              position: absolute;
              bottom: 0;
              left: 0;
              display: flex;
              align-items: center;
              justify-content: center;
              width: 100%;
              height: 0.7rem;
              margin-top: 0.1rem;
            }
          }
          .img-portrait {
            width: 1.5rem;
            height: 1.5rem;
          }
        }
      }
    }
  }
}
</style>